  function SpinnerAdd() {
    const loader_active = document.querySelector('.individual_spice_box .loader_cust_html.loading__spinner');    
    console.log("window.loader_active_count actiive",loader_active);
    loader_active?.classList.remove('hidden');
    document.body.classList.add('active_loader');
  }
  
  function SpinnerRemove() {          
    const loader_remove = document.querySelector('.individual_spice_box .loader_cust_html.loading__spinner');
    console.log("window.loader_active_count remove",loader_remove);    
    loader_remove?.classList.add('hidden');
    document.body.classList.remove('active_loader');             
  }


let products = JSON.parse(localStorage.getItem("bundleProducts") || "[]"); 
let itemArr = [];
// const all_slot = document.querySelectorAll(".slot");
// const slot_no = document.querySelector("[slot-count]"); 
// const originalPrice = document.querySelector('[money_price]'); 

window.all_slot = document.querySelectorAll(".slot");
window.slot_no = document.querySelector("[slot-count]"); 
window.originalPrice = document.querySelector('[money_price]'); 
window.data_wrapp = document.querySelector(".slot_products");

  function slotHideShow(This){
    const all_slot_ = document.querySelectorAll(".slot_main_seletor");
    all_slot_.forEach(el => el.classList.remove("active")); // remove from all    
    This.classList.add("active");    
    const slot_no_inp = This.getAttribute("slot-count-inp"); 
    window.slot_no?.setAttribute("slot-count",slot_no_inp)

    console.log("slot_no_inp",slot_no_inp);

    const total_no = document.querySelectorAll(".total_slot_count");
    if (total_no.length) {
        total_no.forEach(element => {
           if (element.hasAttribute("data-no-space")) {
                    element.innerHTML = slot_no_inp;
            }else {
                element.innerHTML = `${slot_no_inp} `;
            }
        });
    }
    // const total_no = document.querySelector(".total_slot_count");    
    // console.log("total_no",total_no);
    // if(total_no) total_no.innerHTML = slot_no_inp;
    // const selected_count = document.querySelector(".total_slot_count");
    // if(selected_count) selected_count.innerHTML = slot_no_inp;

    const show_slot_ = parseInt(window.slot_no?.getAttribute("slot-count"));   
    window.all_slot?.forEach((el, index) => {
      if (index < show_slot_) {
        el.classList.remove("hide");
      } else {
        el.classList.add("hide"); 
      }
      removeExtraSlot();
    });  
    addGiftPdpBox();
  }

  function fill_image_slot(src,pId,currentTime){    
    const show_slot = parseInt(window.slot_no?.getAttribute("slot-count"));  
    const filledCount = document.querySelectorAll(".slot.filled").length; 
    console.log("filledCount",filledCount,"show_slot",show_slot);
    if (filledCount >= show_slot) return false;     
    const slot = [...window.all_slot].find(el => !el.querySelector("img")?.getAttribute("src"));    
    if(slot.classList.contains("hide")) return false;
    console.log("slotslot",slot,"src",src);
      if (slot) {        
        slot.querySelector("img").src = src;     
        slot.classList.add("filled");
        slot.setAttribute("data-min-pid", pId);
        slot.dataset.time = currentTime;
        return true;
      }            
  }

  function removeExtraSlot(){
    const all_slots = document.querySelectorAll(".slot.filled.hide");  
    all_slots.forEach((slot) => {
      const data_var_id = slot.getAttribute("data-min-pid");
  
      products = products.map(product => {
        
        if (product.id === data_var_id) {
          let qty = Number(product.quantity);
          const bundle_cards = document.querySelectorAll(".gb-item[data-var-id]");
          bundle_cards.forEach(card => {
            if (card.getAttribute("data-var-id") === data_var_id) {
              const qty_el = card.querySelector(".product-quantity__selector"); 
              if (qty > 1) {
                if (qty_el) qty_el.textContent = qty - 1;
              } else {                
                card.remove();
              }
            }
          });
  
          if (qty > 1) {
            return { ...product, quantity: qty - 1 };
          } else {
            return null;
          }
        }
        return product;
      }).filter(Boolean);
  
      slot.querySelector("img").src = "";     
      slot.classList.remove("filled");
      slot.setAttribute("data-min-pid", "");
      slot.dataset.time = "";
    });
  
    localStorage.setItem("bundleProducts", JSON.stringify(products));
  }

  function remove_image_slot(src, productId){
    const matchedSlots = [...window.all_slot].filter(el =>el.getAttribute("data-min-pid") == productId);
    if(!matchedSlots.length) return false;
    const latestSlot = matchedSlots.reduce((latest, current) => {
      const latestTime = Number(latest?.getAttribute("data-time") || 0);
      const currentTime = Number(current?.getAttribute("data-time") || 0);
      return currentTime > latestTime ? current : latest;
    });
    if(!latestSlot) return false;
    if(latestSlot.classList.contains("hide")) return false;

    latestSlot.querySelector("img").src = "";
    latestSlot.classList.remove("filled");
    
    latestSlot.removeAttribute("data-min-pid");
    latestSlot.removeAttribute("data-time");  

    return true;
  }

  async function selectedProductShow(handle, qty, currentTime, var_id , is_gift) {
    try {
      const urllink = is_gift ? `/products/${handle}?variant=${var_id}&view=giftbox` : `/products/${handle}?variant=${var_id}&view=slot-product`;
      // const response = await fetch(`/products/${handle}?variant=${var_id}&view=slot-product`);
      console.log("urllink",urllink,is_gift,"is_gift");
      const response = await fetch(urllink);
      console.log("response",response);
      const productHTML = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(productHTML, 'text/html');
      const mainDivEl = doc.querySelector('.gb-item');
      const qty_inp = doc.querySelector(".product-quantity__selector");
      if(qty_inp){
          qty_inp.value = qty;                  
      }

      if (mainDivEl) {
          mainDivEl.setAttribute("data-handle", handle);  
          mainDivEl.setAttribute("currentTime",currentTime);
          mainDivEl.setAttribute("is_gift_product",is_gift);
          console.log("mainDivEl",mainDivEl)
        return mainDivEl;
      }      
      if(mainDivEl){
        return mainDivEl;
      }else{
        return null;
      }
      return     
    } catch (error) {
      console.error('Error fetching product info:', error);
      return null;
    }
  }    
  
  function priceUpdate(clickedQty,productPrice,qtyInput,removeThis) {      
    const priceGet = parseFloat(productPrice?.getAttribute('bundle_price'));   
    const oregnalprice = parseFloat(productPrice?.getAttribute('bundle_price_without_discount'));  
    const inputBundleval = qtyInput ? parseInt(qtyInput.value) : 0;
    const totalqtyBundle = priceGet * inputBundleval;
    console.log("priceGet",priceGet,"inputBundleval",inputBundleval);
    const totalqtyBundleorejnalprice = oregnalprice * inputBundleval;
    console.log("oregnalprice",oregnalprice,"inputBundleval",inputBundleval)
    const filledCount = document.querySelectorAll(".slot.filled").length;
    const total_selected = document.querySelector(".active_slot_count");
    if(total_selected) total_selected.innerHTML= filledCount;


    if(priceGet){
      if(removeThis && clickedQty) {
        console.log("clickedQty",clickedQty);
        const current_id = clickedQty.getAttribute("currenttime");
        products = products.filter(product => product.currentTime !== current_id);
        localStorage.setItem("bundleProducts", JSON.stringify(products));
        clickedQty.remove();
      }
      productPrice.setAttribute("totalqtyprice",totalqtyBundle);
      productPrice.setAttribute("totalqtypriceorejnal",totalqtyBundleorejnalprice);
      console.log("totalqtyBundleorejnalprice",totalqtyBundleorejnalprice);

      const bundle_product_price = productPrice.querySelector(".bundle_update_price");
      bundle_product_price.innerHTML = theme.Currency.formatMoney(totalqtyBundle, KROWN.settings.shop_money_format);

     price_main_box_total();
     
        
    }

  }



  function price_main_box_total() {


     const elements = [...document.querySelectorAll('[totalqtyprice]')];  
      const total = elements.map(el => Number(el.getAttribute('totalqtyprice')) || 0).reduce((sum, val) => sum + val, 0);
      const totalorgnal = elements.map(el => Number(el.getAttribute('totalqtypriceorejnal')) || 0).reduce((sum, val) => sum + val, 0);
      const discount_amount = document.querySelector(".slot_main_seletor.active")?.getAttribute("slot-count-inp"); 
      const total_footer = window.originalPrice.setAttribute("money_price",total);         
      // window.originalPrice.innerHTML = theme.Currency.formatMoney(total, KROWN.settings.shop_money_format);  
      let  wapper_price = parseFloat(document.querySelector('.gb-box-section .slot_wrap .slot_main_seletor.active')?.getAttribute('data-price-wapper')) || 0;
      wapper_price = 0; 
      const main_price_totle = total + wapper_price;
      console.log("totalorgnal",totalorgnal,"wapper_price",wapper_price)
      const main_price_totle_orejnal = totalorgnal + wapper_price;
      //  const totaldiscount =  main_price_totle - (main_price_totle * 10 / 100);       
      //  document.querySelector('.gb-footer .discount_text').innerHTML = `
      //     PREIS: ${theme.Currency.formatMoney(total, KROWN.settings.shop_money_format)} - <span class="discount">${discount_amount}% Rabatt</span> = ${theme.Currency.formatMoney(totaldiscount, KROWN.settings.shop_money_format)}
      // `;
      // if(main_price_totle_orejnal > main_price_totle) main_price_totle_orejnal = 0;
      const totaldiscount = theme.Currency.formatMoney(main_price_totle, KROWN.settings.shop_money_format) ;
      const totalogrnanalprice = theme.Currency.formatMoney(main_price_totle_orejnal, KROWN.settings.shop_money_format) ;
       window.originalPrice.innerHTML = ` <span class="price-wrapp"> ${totalogrnanalprice} </span> <span class="total_price"> ${totaldiscount} <span class="discount-text"> ${window.originalPrice.getAttribute('data-discount-price-text')} </span> </span>`;    
      // document.querySelector('.gb-footer .discount_text').innerHTML = ` PREIS: ${theme.Currency.formatMoney(total, KROWN.settings.shop_money_format)} - <span class="discount">${discount_amount}% Rabatt</span> = ${theme.Currency.formatMoney(totaldiscount, KROWN.settings.shop_money_format)}`;            


  }



  async function commanData(main_card,bundle_card,is_remove,is_minus,checkinit){    
    window.data_wrapp = document.querySelector(".slot_products");
    const card_product = main_card.closest(".product-item.card");    
      const img_src = card_product?.querySelector(".product-item__image-figure img");    
     
      const card_handle = main_card.getAttribute("data-handle");    
      const qty_parent = main_card.closest("product-quantity");
      const quantityInput = qty_parent.querySelector(".product-quantity__selector");
      const productId = main_card.dataset.varId;
      let currentQty = parseInt(quantityInput.value, 10) || 0;
      const now = Date.now();
      const bundle_card_main = document.querySelector(".gewuerzbox-panel .slot_products");
     
      if(bundle_card_main) { 
        if(is_minus){
          const slot_data = remove_image_slot(img_src.src,productId); 
          if(slot_data == false) return;  
        }else{
          let slot_data = null;          
          if (checkinit) {            
            // for (let i = 0; i < currentQty; i++) {
              slot_data = fill_image_slot(img_src.src, productId, now); 
            // }
          } else {          
            slot_data = fill_image_slot(img_src.src, productId, now); 
          }                    

          if (slot_data ==  false) {
               SpinnerRemove(); 
             const allbundle_card = bundle_card_main.querySelectorAll(".gb-item");      
              const var_id_main = main_card.getAttribute("data-var-id"); 
              const match_bundle_card = Array.from(allbundle_card).find(el => parseInt(el.getAttribute("data-var-id")) === parseInt(var_id_main));                                
              currentQty = currentQty - 1;
              match_bundle_card.querySelector('.bundle_input_qty').value =  currentQty;
          }    
          if (slot_data == false || slot_data == null) return;
        }       

        const var_id = main_card.getAttribute("data-var-id");   
        const first_card = document.querySelector(".gb-item") || null;      
        const bundle_card_before = bundle_card_main.querySelectorAll(".gb-item");      
        const match_bundle_card_before = Array.from(bundle_card_before).find(el => parseInt(el.getAttribute("data-var-id")) === parseInt(var_id));    
         const is_gift =  false;
        // console.log("match_bundle_card_before",match_bundle_card_before);
          if(match_bundle_card_before){
            const bundle_qty = match_bundle_card_before.querySelector(".bundle_input_qty"); 
            const qtyMinus = bundle_qty?.closest('.qty-minus');     
            if(bundle_card == null) bundle_qty.value = currentQty;                                         

            products = products.map(product => {
              if (product.id === productId) product.quantity = bundle_qty.value;
              return product;
            });        
            localStorage.setItem("bundleProducts", JSON.stringify(products));
          }else{
            if (window.data_wrapp) {
              const data_wrapp_info = await selectedProductShow(card_handle, currentQty, now, var_id, is_gift);
              if (data_wrapp_info) {  
                  window.data_wrapp.insertAdjacentHTML('beforeend',data_wrapp_info.outerHTML);
              }
            }
            products = products.filter(p => p.id !== productId);
            if (currentQty > 0) products.push({ id: productId, quantity: currentQty, currentTime: now });
            localStorage.setItem("bundleProducts", JSON.stringify(products)); 
          }     
  
          // remove empty slot card
          const gb_item = document.querySelectorAll(".slot_products .gb-item[data-var-id]");
          const slots = document.querySelectorAll(".slot[data-min-pid]");          
          gb_item.forEach((el) => {
            const varId = el.getAttribute("data-var-id");  
            const isMatch = Array.from(slots).some(slot => slot.getAttribute("data-min-pid") === varId);        
            if (!isMatch) {         
              el.remove();  
              quantityInput.setAttribute("is-first-time",true);                 
            }
          });
                    
        const bundle_card_ = bundle_card_main.querySelectorAll(".gb-item") || null;  
        const match_bundle_card = Array.from(bundle_card_).find(el => parseInt(el.getAttribute("data-var-id")) === parseInt(var_id)) || null;          
        const price = match_bundle_card?.querySelector("[bundle_price]"); 
        // console.log("price..",price,"match_bundle_card",match_bundle_card,"var_id",var_id) ;
        // console.log("bundle_card_",bundle_card_);
        // if(price){          
          priceUpdate(match_bundle_card,price,quantityInput,is_remove);
        // }else{
          // const total_footer = originalPrice.setAttribute("money_price",0);    
          // originalPrice.innerHTML = theme.Currency.formatMoney(0, KROWN.settings.shop_money_format); 
        // }
        // console.log("match_bundle_card",match_bundle_card,"price",price,"quantityInput",quantityInput,"is_remove",is_remove);       
      }
      SpinnerRemove(); 
  }

  function addProductInSlot(This,checkinit){   
    console.log("addProductInSlot....");
      // SpinnerAdd();
    const cards = null;
    const is_remove = false;   
    const card_product = This.closest(".product-item");
    // This.value = 1;    
    if(card_product){  
        const is_min = false;        
      commanData(This,cards,is_remove,is_min,checkinit);
     
    } 
  }
  
  function bundleQty(This,remove_this){  
      SpinnerAdd();
    const bcard_id = This.closest(".gb-item[data-var-id]")?.getAttribute("data-var-id") || null;
    console.log("bcard_id",bcard_id);
    if(bcard_id){
      const card_id = document.querySelector(`.product-item[data-var-id='${bcard_id}']`);
      const card_qty = card_id.querySelector(".product-quantity__selector");      
      const main_cards = null; 
      card_qty.value = This.value;
      const is_min = false;      
      console.log("bundleqty",bundleQty);
      commanData(card_qty,This,remove_this,is_min);      

    }
  }

  function minBundleQty(This,remove_this,is_gift){ 
    const bcard_id = This.closest(".gb-item[data-var-id]")?.getAttribute("data-var-id");
    console.log("bcard_id",bcard_id)
    if(is_gift && bcard_id){
       This.closest(".gb-item[data-var-id]").remove();  
        const bundle_card_main = document.querySelector(".gewuerzbox-panel .slot_products");
         const bundle_card_ = bundle_card_main.querySelectorAll(".gb-item") || null;  
        const match_bundle_card = Array.from(bundle_card_).find(el => parseInt(el.getAttribute("data-var-id")) === parseInt(bcard_id)) || null;          
        const price = match_bundle_card?.querySelector("[bundle_price]"); 
           priceUpdate(match_bundle_card,price,null,false);
       return;
    }
    if(bcard_id){
      const card_id = document.querySelector(`.product-item[data-var-id='${bcard_id}']`);
      const card_qty = card_id.querySelector(".product-quantity__selector");  
      card_qty.value = This.value;
      const main_cards = null; 
      const is_min = true;
      commanData(card_qty,This,remove_this,is_min);
    }
  }

  function BundleAddToCart(Button){      
      const active_slot = document.querySelector(".slot_main_seletor.active").innerHTML;        
      document.querySelectorAll('.gb-item').forEach(item => {
        const productVarId = item.dataset.varId;
        const product = products.find(p => p.id === productVarId);        
        // if(active_slot){
          const customProperties = {'Bundle Item': `${active_slot}` };        
        // }else{
          // const customProperties = {'Bundle Item': 'Yes'};        
        // }
        if (product) itemArr.push({ id: productVarId, quantity: product.quantity , properties: customProperties});
      });      
      const is_optionle_selected = document.querySelector(".optioale_product");
      const optionalSelected = document.querySelector(".optioale_product:checked");
      const is_add_box = document.querySelector(".slot_main_seletor.active");
      const box_select = parseInt(is_add_box.getAttribute("slot-count-inp"));
      const box_product = is_add_box?.getAttribute("data-product-dose");      
      const total_selected = parseInt(document.querySelector(".active_slot_count")?.textContent);
       const now = Date.now();
      if(box_product){
          const customProperties = {'Free box up to': `${box_select}` };        
          if(box_product) { itemArr.push({ id: box_product, quantity: 1 , properties: customProperties}); }
      }
      /* show product of free */
      // if(optionalSelected){
      //   const product_id = optionalSelected.getAttribute("optionale-data-var-id");
      //   const customProperties = {'Bundle Item': `${active_slot}` };         
      //     if(product_id) { itemArr.push({ id: product_id, quantity: 1 , properties: customProperties}); }          
      // }

    /* show product automatic add the 2 product */
    // const active_dose = document.querySelector(".slot_main_seletor.active");
    // const slot_no_inp = active_dose.getAttribute("slot-count-inp"); 
    // const get_dose_product = parseInt(active_dose.getAttribute("data-product-dose"));        
    // if (get_dose_product) {
    //   itemArr = itemArr.filter(item => !item.properties?.['Product with Dose']);
    //   itemArr.push({id: get_dose_product,quantity: 1,properties: {'Product with Dose': slot_no_inp}});
      
    //   products = products.filter(p => p.id !== get_dose_product);
    //   products.push({ id: get_dose_product, quantity: 1, currentTime: now });
    // }
    // console.log("products",products);      
    const visibleSlots = document.querySelectorAll(".slot:not(.hide)");

      const allImagesFilled = [...visibleSlots].every(slot => {
        const img = slot.querySelector("img");
        return img && img.getAttribute("src") && img.getAttribute("src").trim() !== "";
      })
      console.log("allImagesFilled",allImagesFilled)
      if (itemArr.length > 0 && total_selected > 0) {
        if(allImagesFilled){
          customAddToCart({ items: itemArr }, true);
        }else{
           const popupElement = document.querySelector('.popup_data_info');
          if (popupElement) {
              // popupElement.style.display = 'flex';
              document.body.classList.add('popup-active');
          }
        }
      }
      if(products != [])  localStorage.removeItem('bundleProducts');
  }

      document.querySelector('.close_btn')?.addEventListener("click", (event) => {
         document.body.classList.remove('popup-active');
      });

  function customAddToCart(product, openDrawer) {    
    fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { "Accept": "application/json", "Content-Type": "application/json" },
        body: JSON.stringify(product)
    })
    .then(response => response.json())
    .then(response => console.log("Response:", response))
    .catch(error => console.error('Error:', error))
    .finally(() => {    
        if (openDrawer) window.refreshCart();
    });
  }

  async function addGiftPdpBox(){   
    window.data_wrapp_gift = document.querySelector(".slot_products-gift");
    const get_gift_pro_qty = window.data_wrapp_gift?.querySelector('.is_gift_temp .qty-selector');  
    // console.log("min_budnle_qty",get_gift_pro_qty);  
    // if(get_gift_pro_qty) minBundleQty(get_gift_pro_qty,false,true);

    const is_add_box = document.querySelector(".slot_main_seletor.active");
    const box_select = parseInt(is_add_box.getAttribute("slot-count-inp"));
    const box_product = is_add_box?.getAttribute("data-product-dose");     
    const box_hanlde = is_add_box?.getAttribute("data-product-handle");  
    const total_selected = parseInt(document.querySelector(".active_slot_count")?.textContent);
    const now = Date.now();
    if(box_product){
        const customProperties = {'Free box up to': `${box_select}` };         
        const qty =  1;
        const is_gift =  true;
          if (window.data_wrapp_gift) {
            const data_wrapp_info = await selectedProductShow(box_hanlde, qty, now, box_product, is_gift);            
            if (data_wrapp_info) {   
              
             window.data_wrapp_gift.innerHTML = '';
             window.data_wrapp_gift.appendChild(data_wrapp_info);

            price_main_box_total();

            //  const elements = [...document.querySelectorAll('[totalqtyprice]')];  
            // const total = elements.map(el => Number(el.getAttribute('totalqtyprice')) || 0).reduce((sum, val) => sum + val, 0);
            // const totalorgnal = elements.map(el => Number(el.getAttribute('totalqtypriceorejnal')) || 0 ).reduce((sum, val) => sum + val, 0);
            // const discount_amount = document.querySelector(".slot_main_seletor.active")?.getAttribute("slot-count-inp"); 
            // const total_footer = window.originalPrice.setAttribute("money_price",total);                     
            //             console.log("total",total);
            // const main_price_totle = total;
            // let main_price_totle_orejnal = totalorgnal;   
            // //  if(main_price_totle_orejnal >= main_price_totle) main_price_totle_orejnal = 0;   
            //     console.log("total",main_price_totle_orejnal);
            // const totaldiscount = theme.Currency.formatMoney(main_price_totle, KROWN.settings.shop_money_format) ;
            // const totalogrnanalprice = theme.Currency.formatMoney(main_price_totle_orejnal, KROWN.settings.shop_money_format) ;
            // window.originalPrice.innerHTML = ` <span class="price-wrapp"> ${totalogrnanalprice} </span> <span class="total_price"> ${totaldiscount} <span class="discount-text"> ${window.originalPrice.getAttribute('data-discount-price-text')} </span> </span>`;    
            }
          }
      }   
  }


  // price set
  const buttonSlots = document.querySelectorAll(".slot_main_seletor"); 
  buttonSlots?.forEach(buttonSlot => {
    buttonSlot?.addEventListener("click", async () => {    
        const is_optionale_inlays = document.querySelectorAll(".gb-radio-input");
        console.log("is_optionale_inlays",is_optionale_inlays.checked);
        is_optionale_inlays?.forEach(checked_item => {   
          console.log("checked_item?.checked",checked_item?.checked)
          if(checked_item?.checked){
            // price set on the product
            const parent_el = checked_item.closest(".gb-packaging-item") || null;        
            const get_active_price = buttonSlot.getAttribute("data-price-wapper") || null;
            const set_active_price = parent_el?.querySelector(".gb-price") || null;        
            console.log("set_active_price",set_active_price);
            console.log("get_active_price",get_active_price)          
            if(set_active_price != null && get_active_price != null){
              console.log("get_active_price",get_active_price,"set_active_price",set_active_price)
              set_active_price.innerHTML =  theme.Currency.formatMoney(get_active_price, KROWN.settings.shop_money_format) ; 
                
              // product add
            addGiftPdpBox();
              //total
              console.log("set_active_price",set_active_price);

              price_main_box_total();

              //  const elements = [...document.querySelectorAll('[totalqtyprice]')];  
              //   const total = elements.map(el => Number(el.getAttribute('totalqtyprice')) || 0).reduce((sum, val) => sum + val, 0);
              //   const totalorgnal = elements.map(el => Number(el.getAttribute('totalqtypriceorejnal')) || 0 ).reduce((sum, val) => sum + val, 0);
              //   const discount_amount = document.querySelector(".slot_main_seletor.active")?.getAttribute("slot-count-inp"); 
              //   const total_footer = window.originalPrice.setAttribute("money_price",total);                     
              //               console.log("total",total);
              //   const main_price_totle = total + parseFloat(get_active_price);
              //   const main_price_totle_orejnal = totalorgnal + parseFloat(get_active_price);  
                
              //   // if(main_price_totle_orejnal > main_price_totle) main_price_totle_orejnal = 0;
                
              //   const totaldiscount = theme.Currency.formatMoney(main_price_totle, KROWN.settings.shop_money_format) ;
              //   const totalogrnanalprice = theme.Currency.formatMoney(main_price_totle_orejnal, KROWN.settings.shop_money_format) ;
              //   window.originalPrice.innerHTML = ` <span class="price-wrapp"> ${totalogrnanalprice} </span> <span class="total_price"> ${totaldiscount} <span class="discount-text"> ${window.originalPrice.getAttribute('data-discount-price-text')} </span> </span>`;    

            }  
          }
        });
    });
  });

  (function () {
    setTimeout(() => {
      addGiftPdpBox();
      document.querySelector("[slot-count-inp='4']")?.click();
    }, 1000);
  })();


const slots = document.querySelectorAll(".slot:not(.hide)");
slots.forEach(slot => {
  console.log(slot);
});